import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CouponsectionService {

  private dataSubject = new BehaviorSubject<string>('Initial data');
  public data$ = this.dataSubject.asObservable();
  excelContent: any;

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  sendData(data: string) {
    this.dataSubject.next(data);
  }

  setExcelData(data) {
    this.excelContent = data;
  }

  getExcelData() {
    return this.excelContent
  }

  getParkByCLAId() {
    return this.apiService.get(`${APIs.getParkByClaId}?claId=${localStorage.getItem('claAdminId')}`).pipe(map(response => {
      if (response.isValid) {
        // this.parkDropDownDetails.next(response.list);
        console.log(response.list);
      }
      return response;
    }))
  }

  createNewCouponData(body?: any): Observable<any> {
    return this.apiService.post(APIs.createNewCoupon, body).pipe(map(response => {
      return response;
    }));
  }

  updateNewCouponData(body?: any): Observable<any> {
    return this.apiService.post(APIs.updateNewCoupon, body).pipe(map(response => {
      return response;
    }));
  }

  getCouponList(): Observable<any> {
    return this.apiService.get(APIs.getAllCouponList).pipe(map(response => {
      // return response?.list;
      return response;
    }));
  }

  getCuoponDetails(id: string): Observable<any> {
    return this.apiService.get(APIs.getSingleCouponDetails + '?couponId=' + id).pipe(map(response => {
      return response;
    }));
  }

  removeCoupon(body: any): Observable<any> {
    return this.apiService.post(APIs.removeCouponData, body).pipe(map(response => {
      return response;
    }));
  }

  createBulkUploadCoupon(data): Observable<any> {
    return this.apiService.post(APIs.bulkUploadFileCoupon, data).pipe(
      map((response) => {
        return response;
      })
    );
  }
}
